import { bind, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { tryFind, tryPick, choose } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { Tree_tryFind, Tree_tryNode, Tree_tryLeaf } from "../Shared/Tree.js";

/**
 * Given a document tree, take all documents that are direct children to this node
 */
export function getDocuments(tree) {
    return defaultArg(map((tupledArg) => choose(Tree_tryLeaf, tupledArg[1]), Tree_tryNode(tree)), []);
}

export function tryFindCategory(categoryId, tree) {
    return Tree_tryFind((_arg) => false, (node) => (node.Id === categoryId), tree);
}

export function getDocumentsForCategory(machineCategories, machineId, categoryId) {
    return defaultArg(bind((mc_1) => tryPick((arg) => map(getDocuments, tryFindCategory(categoryId, arg)), mc_1.Trees), tryFind((mc) => (mc.Machine.Id === machineId), machineCategories)), []);
}

